// import { OPEN_AI_ASSISTANT_ID, openAI } from 'api/openai';
import { AppConfigV1BaseServerRepo } from 'core/repository/base-server/v1/app-config.repo';
import { useEffect, useState } from 'react';

type useOpenAISearchType = {
  props: {
    query: string | undefined;
  };
  return: {
    result: string | undefined;
  };
};

export function useOpenAISearch({
  query,
}: useOpenAISearchType['props']): useOpenAISearchType['return'] {
  const [result, setResult] = useState<string>();
  // const [thread, setThread] = useState<any>(null);

  const initThread = async () => {
    // const thread = await openAI.beta.threads.create();
    const threadId = await new AppConfigV1BaseServerRepo().getOpenAiThread();
    const response = await new AppConfigV1BaseServerRepo().getOpenAiMessage({
      content: query || '',
      threadId,
    });

    // console.log('response--',response);
    setResult(response);
    // await openAI.beta.threads.messages.create(thread, {
    //   role: 'user',
    //   content: query || '',
    // });

    // setThread(null);
  };

  useEffect(() => {
    initThread();
  }, []);

  // useEffect(() => {
  //   if (!!thread?.id) {
  //     openAI.beta.threads.runs
  //       .stream(thread.id, {
  //         assistant_id: OPEN_AI_ASSISTANT_ID,
  //       })
  //       .on('textCreated', () => {})
  //       .on('textDelta', (textDelta) => {
  //         setResult((prev) => {
  //           return prev ? prev.concat(textDelta.value || '') : textDelta.value;
  //         });
  //       });
  //   }
  // }, [thread]);

  return { result };
}
